import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  'forgot.password.page.title': {
    id: 'forgot.password.page.title',
    defaultMessage: 'Forgot Password | {siteName}',
    description: 'forgot password page title',
  },
  'forgot.password.page.heading': {
    id: 'forgot.password.page.heading',
    defaultMessage: 'Reset your password',
    description: 'The page heading for the forgot password page.',
  },
  'forgot.password.page.instructions': {
    id: 'forgot.password.page.instructions',
    defaultMessage: 'Enter your email you used to sign up. We\'ll send you a {length}-character code to verify it\'s you',
    description: 'Instructions message for forgot password page.',
  },
  'forgot.password.page.invalid.email.message': {
    id: 'forgot.password.page.invalid.email.message',
    defaultMessage: 'Enter a valid email address',
    description: 'Invalid email address message for input field.',
  },
  'forgot.password.page.email.field.label': {
    id: 'forgot.password.page.email.field.label',
    defaultMessage: 'Email',
    description: 'Email field label for the forgot password page.',
  },
  'forgot.password.page.submit.button': {
    id: 'forgot.password.page.submit.button',
    defaultMessage: 'Send code',
    description: 'Submit button text for the forgot password page.',
  },
  'forgot.password.email.sent.page.title': {
    id: 'forgot.password.email.sent.page.title',
    defaultMessage: 'Check your email {enter}and reset your password',
    description: '',
  },
  'forgot.password.email.sent.page.subtitle': {
    id: 'forgot.password.email.sent.page.subtitle',
    defaultMessage: 'We sent a code to {email}. {enter} Enter it on the next screen to reset your password.',
    description: '',
  },
  'forgot.password.email.sent.page.additional.email.sent': {
    id: 'forgot.password.email.sent.page.additional.email.sent',
    defaultMessage: 'We sent an additional code to {email}. {enter} Enter it on the next screen to reset your password.',
    description: '',
  },
  'forgot.password.email.sent.page.resend.email': {
    id: 'forgot.password.email.sent.page.resend.email',
    defaultMessage: 'Resend email',
    description: '',
  },
  'forgot.password.email.sent.page.didnt.got.text': {
    id: 'forgot.password.email.sent.page.didnt.got.text',
    defaultMessage: 'Didn\'t get it?',
    description: '',
  },
  'forgot.password.email.sent.page.button': {
    id: 'forgot.password.email.sent.page.button',
    defaultMessage: 'Enter code',
    description: '',
  },
  'forgot.password.email.sent.user.is.not.exist': {
    id: 'forgot.password.email.sent.user.is.not.exist',
  defaultMessage: 'This email isn\'t registered for password login. If it’s linked to an SSO account, please sign in there',
  description: 'Shown when the email is not registered but may belong to an SSO account',
  },
  'forgot.password.error.alert.title': {
    id: 'forgot.password.error.alert.title.',
    defaultMessage: 'We were unable to contact you.',
    description: 'Failed to send password recovery email.',
  },
  'forgot.password.error.message.title': {
    id: 'forgot.password.error.message.title',
    defaultMessage: 'An error occurred.',
    description: 'Title for message that appears when error occurs for password assistance page',
  },
  'forgot.password.request.in.progress.message': {
    id: 'forgot.password.request.in.progress.message',
    defaultMessage: 'Your previous request is in progress, please try again in a few moments.',
    description: 'Message displayed when previous password reset request is still in progress.',
  },
  'forgot.password.empty.email.field.error': {
    id: 'forgot.password.empty.email.field.error',
    defaultMessage: 'Enter your email',
    description: 'Error message that appears when user tries to submit empty email field',
  },
  'forgot.password.email.help.text': {
    id: 'forgot.password.email.help.text',
    defaultMessage: 'The email address you used to register with {platformName}',
    description: 'text help for the email',
  },
  'forgot.password.email.placeholder': {
    id: 'forgot.password.email.placeholder',
    defaultMessage: 'name@example.com',
    description: '',
  },
  'forgot.password.email.input.label': {
    id: 'forgot.password.email.input.label',
    defaultMessage: 'Email address',
    description: 'Label text for email input field on login page',
  },
  'back.to.sign.in': {
    id: 'back.to.sign.in',
    defaultMessage: 'Back to sign in',
    description: 'Back button text to return to login page',
  },  
  // Confirmation Alert Message
  'confirmation.message.title': {
    id: 'confirmation.message.title',
    defaultMessage: 'Check your email',
    description: 'Forgot password confirmation message title',
  },
  'confirmation.support.link': {
    id: 'confirmation.support.link',
    defaultMessage: 'contact technical support',
    description: 'Technical support link text',
  },
  'need.help.sign.in.text': {
    id: 'need.help.sign.in.text',
    defaultMessage: 'Need other help signing in?',
    description: 'Sign in help link on forgot password page',
  },
  'additional.help.text': {
    id: 'additional.help.text',
    defaultMessage: 'For additional help, contact {platformName} support at ',
    description: 'additional help text on forgot password page',
  },
  'sign.in.text': {
    id: 'sign.in.text',
    defaultMessage: 'Sign in',
    description: 'login page link on password page',
  },
  'extend.field.errors': {
    id: 'extend.field.errors',
    defaultMessage: '{emailError} below.',
    description: 'extends the field error for alert message',
  },
  // Reset password token validation failure
  'invalid.token.heading': {
    id: 'invalid.token.heading',
    defaultMessage: 'Invalid password reset link',
    description: 'Alert heading when reset password link is invalid',
  },
  'invalid.token.error.message': {
    id: 'invalid.token.error.message',
    defaultMessage: 'This password reset link is invalid. It may have been used already. Enter your email below to receive a new link.',
    description: 'Alert message when reset password link has expired or is invalid',
  },
  'token.validation.rate.limit.error.heading': {
    id: 'token.validation.rate.limit.error.heading',
    defaultMessage: 'Too many requests',
    description: 'Too many request at server end point',
  },
  'token.validation.rate.limit.error': {
    id: 'token.validation.rate.limit.error',
    defaultMessage: 'An error has occurred because of too many requests. Please try again after some time.',
    description: 'Error message that appears when server responds with 429 error code',
  },
  'token.validation.internal.sever.error.heading': {
    id: 'token.validation.internal.sever.error.heading',
    defaultMessage: 'Token validation failure',
    description: 'Failed to validate reset password token error message.',
  },
  'token.validation.internal.sever.error': {
    id: 'token.validation.internal.sever.error',
    defaultMessage: 'An error has occurred. Try refreshing the page, or check your internet connection.',
    description: 'Error message that appears when server responds with 500 error code',
  },
  // Error messages
  'internal.server.error': {
    id: 'internal.server.error',
    defaultMessage: 'An error has occurred. Try refreshing the page, or check your internet connection.',
    description: 'Error message that appears when server responds with 500 error code',
  },
});
export default messages;
